import { connect } from 'react-redux';
import { startPrintProductLabels } from '../../reducers/order.reducers';
import ArticleList from './article-list';

const mapStateToProps = (state) => ({
    printingProductLabels: state.orders.printingProductLabels
});

const mapDispatchToProps = (dispatch) => ({
    printProductLabels: (printLabelInfos) => dispatch(startPrintProductLabels({printLabelInfos})),
});

export default connect(mapStateToProps, mapDispatchToProps)(ArticleList);
